import { IDB_NAME, IDB_TABLE_LOCATIONS } from '@/util/constants';
import Dexie from 'dexie';

const idb = new Dexie(IDB_NAME);
// Indexed DB used for offline locations, other things should be saved via util/local-storage
idb.version(1).stores(
  { [IDB_TABLE_LOCATIONS]: 'fb_city_id,name,type' }, // index keys
);

export default idb;



// WEBPACK FOOTER //
// ./src/util/indexed-db.js